import { useEffect } from 'react';
import { useScriptLoad } from './hooks';
import { useAnalytics } from './FueledAnalytics';
import { TRACKING_EVENTS } from './fueled.events';

export function FueledKeynesScript({ withKey: { upixelId, advertiserId } }) {
  const { register, subscribe } = useAnalytics();
  const ready = register('fueled-keynes-script');
  const { status } = useScriptLoad(
    {
      id: 'fueled-keynes-script',
      src: 'https://js.adsrvr.org/up_loader.1.1.0.js',
    },
    'head'
  );
  useEffect(() => {
    if (status !== 'ready') return;

    const pageViewListener = () => {
      if (
        window?.ttd_dom_ready &&
        typeof window?.TTDUniversalPixelApi === 'function'
      ) {
        window?.ttd_dom_ready(() => {
          const universalPixelApi = new window.TTDUniversalPixelApi();
          universalPixelApi.init(
            advertiserId,
            [upixelId],
            'https://insight.adsrvr.org/track/up'
          );
        });
      }
    };

    const unsubscribe = subscribe(TRACKING_EVENTS.PAGE_VIEW, pageViewListener);

    ready();
    // eslint-disable-next-line consistent-return
    return () => {
      unsubscribe();
    };
  }, [status]);

  return (
    <img
      width="1"
      height="1"
      alt=""
      src="//action.dstillery.com/orbserv/nspix?adv=cl172306849900104&ns=8766&nc=BruMate-Site-Visitor&ncv=71"
    />
  );
}
